export const getTerms = state => state.toJS();



// WEBPACK FOOTER //
// ./src/redux/selectors/TermsSelectors.js